import axios from '../../axios';

const getTransferStatus = (serviceConfirmationStatus) => {
  // NoResponseYet = 0 -  we are still waiting
  // Accepted = 1 -  we are ready to take payment
  // Declined = 2 -  service owner is unable to transfer the client
  // AcceptedWithChanges = 3 -  service owner requires changes
  // NotApplicable = 4 -  booking items never required confirmation to begin with (like a property or wine)
  // ManuallyAccepted = 5 -  a user has manually accepted in think admin
  switch (serviceConfirmationStatus) {
    case 0:
      return 12; // waiting for confirmation
    case 1:
      return 15; // ready for payment
    case 2:
      return 13; // declined
    case 3:
      return 14; // AcceptedWithChanges
    case 4:
      return 15; // NotApplicable
    case 5:
      return 15; // ManuallyAccepted
    default:
      return 0;
  }
};
const getPassengerLabel = (count) => (count > 1 ? `${count} passengers` : `${count} passenger`);
const createTransfersItem = (booking, rootGetters) => {
  const chauffeurType = ['chauffeur', 'chauffeurHalfday'].includes(booking.transferType) ? booking.transferType : 'chauffeur';
  const transfer = {
    itemBookingId: booking.id, // to create consolidate bookings
    uniqueIdentifier: booking.uniqueIdentifier,
    id: 0, // handled by the store
    transferTypeId: booking.transfer.type,
    transferType: booking.transferType, // airport, place, chauffeur, chauffeurHalfday
    transferId: booking.transfer.id,
    chauffeurType,
    direction: ['', 'fromVilla', 'toVilla'][booking.serviceDirection], // [ fromVilla, toVilla ]
    serviceDirection: booking.serviceDirection,
    destinationFrom: booking.serviceLeavingFrom,
    destinationTo: booking.serviceTripDestination,
    bookingItem: {
      propertyId: booking.transfer.propertyId,
      regionPlaceId: booking.transfer.regionPlaceId,
      bookingId: booking.bookingId,
      transferId: booking.transfer.id,
    },
    selectedVilla: rootGetters['sca/getVillaByID'](booking.transfer.propertyId),
    locationID: booking.transfer.regionPlaceId,
    flightNumber: booking.serviceFlightReference,
    date: moment(booking.dateIn).format('YYYY-MM-DD'),
    flightTime: booking.serviceFlightArrivalTime,
    pickupTime: booking.serviceMeetingTime,
    returnTime: booking.serviceReturnTime,
    isReturn: booking.serviceIsReturn,
    passengerName: booking.contactName,
    contactNumber: booking.contactPhone,
    passengers: {
      adults: booking.peopleAdults,
      children: booking.peopleChildren,
      infants: booking.peopleBabies,
      total: booking.peopleTotal,
    },
    passengersLabel: getPassengerLabel(booking.peopleTotal),
    carBoosterSeat: booking.serviceRequiresBoosterSeat,
    extraLuggage: booking.serviceRequiresExtraLuggage,
    notes: booking.note,
    price: booking.totalPrice,
    status: getTransferStatus(booking.serviceConfirmationStatus),
    serviceConfirmationStatus: booking.serviceConfirmationStatus,
    serviceRequiresConfirmation: booking.serviceRequiresConfirmation,
    selected: true,
  };

  const date1 = new Date(`${moment(transfer.date).format('YYYY MM DD')} ${transfer.pickupTime}`);
  const travelDateTime = moment(date1).format();
  const dateInaWeek = moment().add(1, 'week');
  const isBefore = moment(transfer.date).isBefore(dateInaWeek);
  let returnDateTime;
  if (booking.serviceIsReturn) {
    const date2 = new Date(`${moment(transfer.date).format('YYYY MM DD')} ${transfer.returnTime}`);
    returnDateTime = moment(date2).format();
  }

  let flightArrivalTime;
  if (transfer.flightTime.length === 5) {
    const date3 = new Date(`${moment(transfer.date).format('YYYY MM DD')} ${transfer.flightTime}`);
    flightArrivalTime = moment(date3).format();
  }

  const bookingItem = {
    uniqueIdentifier: booking.uniqueIdentifier,
    propertyId: booking.transfer.propertyId,
    regionPlaceId: booking.transfer.regionPlaceId,
    bookingId: booking.bookingId,
    transferId: booking.transfer.id,
    villaBookingItemId: booking.transfer.propertyId,
    adultCount: booking.peopleAdults,
    childCount: booking.peopleChildren,
    infantCount: booking.peopleBabies,
    isReturn: booking.serviceIsReturn,
    travelDateTime,
    returnDateTime,
    flightArrivalTime,
    type: ['chauffeur', 'chauffeurHalfday'].includes(booking.transferType) ? chauffeurType : booking.transferType,
    direction: ['', 'fromVilla', 'toVilla'][booking.serviceDirection], // [ fromVilla, toVilla ]
    flightNumber: booking.transferType === 'airport' ? booking.serviceFlightReference : '',
    mainPassengerName: booking.contactName,
    mainPassengerContactNumber: booking.contactPhone,
    requireBoosterSeat: booking.serviceRequiresBoosterSeat,
    extraLuggage: booking.serviceRequiresExtraLuggage,
    notesToDriver: booking.note,
    price: booking.totalPrice,
    selected: true,
  };
  transfer.bookingItem = bookingItem;
  return transfer;
};

export default {
  namespaced: true,
  state: {
    transferType: 'airport',
    transferBookings: [],
    transferOptions: [],
    transferOptionsBookings: [],
    itemEdit: null,
    transferTypes: ['airport', 'place', 'chauffeur', 'chauffeur'], // id is array index, 0,1,2,3
    provisionalTransferBookings: [],
    confirmedTransferBookings: [],
  },
  getters: {
    getTransferType: (state) => state.transferType,
    getTransferBookings: (state) => state.transferBookings,
    getItemEdit: (state) => state.itemEdit,
    getTransferOptions: (state) => state.transferOptions,
    getTransferOptionsBookings: (state) => state.transferOptionsBookings,
    getProvisionalTransferBookings: (state) => state.provisionalTransferBookings.sort((a, b) => b.id - a.id),
    getConfirmedTransferBookings: (state) => state.confirmedTransferBookings.sort((a, b) => b.id - a.id),
    readyForPaymentTransfers: (state) => state.provisionalTransferBookings.filter((booking) => booking.bookingItems.some((item) => item.status === 15)).sort((a, b) => b.id - a.id),
    awaitingConfirmationTransfers: (state) => state.provisionalTransferBookings.filter((booking) => booking.bookingItems.some((item) => [12].includes(item.status))).sort((a, b) => b.id - a.id),
    unavailableTransfers: (state) => state.provisionalTransferBookings.filter((booking) => booking.bookingItems.some((item) => [13].includes(item.status))).sort((a, b) => b.id - a.id),
    acceptedWithChangesTransfers: (state) => state.provisionalTransferBookings.filter((booking) => booking.bookingItems.some((item) => [14].includes(item.status))).sort((a, b) => b.id - a.id),
  },
  mutations: {
    addBooking(state, booking) {
      const index = state.transferBookings.findIndex((item) => item.uniqueIdentifier == booking.uniqueIdentifier);
      if (index === -1) {
        booking.id = state.transferBookings.length + 1;
        booking.editInProcess = false;
        booking.selected = true;
        state.itemEdit = null;
        state.transferBookings.push(booking);
      }
      else {
        state.transferBookings.splice(index, 1, booking);
      }
    },
    updateBookingComplete(state, booking) {
      booking.editInProcess = false;
      const index = state.transferBookings.findIndex((item) => item.uniqueIdentifier == booking.uniqueIdentifier);
      state.transferBookings.splice(index, 1, booking);
    },
    removeBooking(state, booking) {
      booking.editInProcess = false;
      state.itemEdit = null;
      state.transferBookings = state.transferBookings.filter((item) => item.uniqueIdentifier != booking.uniqueIdentifier);
      state.transferBookings.forEach((item, i) => {
        item.id = i + 1;
        item.editInProcess = false;
      });
    },
    emptyBasket(state) {
      state.transferBookings.length = 0;
    },
    setTransferType(state, value) {
      state.transferType = value;
    },
    setTransferBookings(state, value) {
      state.transferBookings = value;
    },
    setTransferOptionsBookings(state, value) {
      state.transferOptionsBookings = value;
    },
    setItemEdit(state, value) {
      state.itemEdit = value;
    },
    setProvisionalTransferBookings(state, value) {
      state.provisionalTransferBookings = value;
    },
    setConfirmedTransferBookings(state, value) {
      state.confirmedTransferBookings = value;
    },
  },
  actions: {
    fetchTransferOptions({ state }, payload) {
      return new Promise((resolve, reject) => {
        axios.get(`/core/transfers/foroptions/propertyid/${payload.id}/type/${payload.type}`)
          .then((res) => {
            state.transferOptions = res.data;
            resolve(res.data);
          })
          .catch((error) => {
            // console.log('error: ', error);
            reject(error);
          });
      });
    },

    fetchTransfersForBookings({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const { passengercount, dateOfTravel } = payload;
        const paramsToSend = {
          ...!!passengercount && { passengercount },
          ...!!dateOfTravel && { dateOfTravel },
        };
        axios.get(`/core/transfers/forbooking/propertyid/${payload.id}/type/${payload.type}`, { params: paramsToSend })
          .then((res) => {
            commit('setTransferOptionsBookings', res.data);
            resolve(res.data);
          })
          .catch((error) => {
            console.log('error: ', error);
            reject(error);
          });
      });
    },

    requestTransfer({ state, commit }, villabookingitemid) {
      return new Promise((resolve, reject) => {
        const bookingItems = state.transferBookings.map(({ bookingItem }) => bookingItem).filter((item) => item.villaBookingItemId === villabookingitemid);
        axios.post(`/core/bookings/transfer/request/villabookingitemid/${villabookingitemid}`, bookingItems)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            console.log('error: ', error);
            reject(error);
          });
      });
    },

    requestSingleTransfer({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/bookings/transfer/request/villabookingitemid/${data.id}`, [data.item])
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    hideBookingItem({ state }, bookingId) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/bookings/${bookingId}/hideallbookingitems`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    consolidateForPayment({ state }, bookings) {
      return new Promise((resolve, reject) => {
        axios.post('/core/bookings/transfer/consolidateforpayment', bookings)
          .then((res) => {
            resolve(res.data);
          })
          .catch((error) => {
            console.log('error: ', error);
            reject(error);
          });
      });
    },

    async fetchUserTransferBookingItems({ state, commit, dispatch, rootGetters }, userId) {
      const bookings = await dispatch('bookings/fetchAllAndRequested', userId, { root: true });
      const provisionalTransferBookings = bookings.provisional.filter((booking) => booking.bookingItems.some((item) => !!item.transfer));
      provisionalTransferBookings.forEach((booking) => booking.bookingItems.forEach((item) => {
        item.transferType = state.transferTypes[item.transfer.type];
        item.status = getTransferStatus(item.serviceConfirmationStatus);
        item.transferBooking = createTransfersItem(item, rootGetters);
        if ([15, 10].includes(item.status)) {
          commit('addBooking', item.transferBooking);
        }
      }));
      const upcomingConfirmed = bookings.upcomingConfirmed.filter((booking) => booking.bookingItems.some((item) => !!item.transfer));
      upcomingConfirmed.forEach((booking) => booking.bookingItems.forEach((item) => {
        item.transferType = state.transferTypes[item.transfer.type];
        item.status = 5;
        item.transferBooking = createTransfersItem(item, rootGetters);
      }));
      commit('setProvisionalTransferBookings', provisionalTransferBookings);
      commit('setConfirmedTransferBookings', upcomingConfirmed);
      return bookings;
    },

  },
};
